module.exports = __webpack_public_path__ + "img/407.eb5d4d01.jpg";